import { DisponibiliteEpargne, ToleranceRisque } from '@lib/models/generated/graphql';

export const DEFAULT_DISPONIBILITE_OPTIONS = [
  {
    id: 'ToujoursDispo',
    value: DisponibiliteEpargne.ToujoursDispo,
    label: "J'ai besoin de toute mon épargne à tout moment y compris avant le terme de l'horizon de placement.",
  },
  {
    id: 'ConserverAvecRetraits',
    value: DisponibiliteEpargne.ConserverAvecRetraits,
    label:
      "Mon épargne de précaution est suffisante, je prévois de conserver mon placement sur l'horizon sélectionné mais avec une possibilité d'effectuer des retraits ponctuels et limités en cas de besoins exceptionnels non anticipés.",
  },
  {
    id: 'ConserverSansRetrait',
    value: DisponibiliteEpargne.ConserverSansRetrait,
    label:
      "Mon épargne de précaution est suffisante, je prévois de conserver mon placement sur l'horizon sélectionné sans effectuer aucun retrait.",
  },
  {
    id: 'DedieSansRetrait',
    value: DisponibiliteEpargne.DedieRetraite,
    label:
      "Je souhaite dédier cette épargne à la retraite et accepte une durée de blocage jusqu'à la retraite sans pouvoir effectuer des retraits.",
  },
  {
    id: 'Transmission',
    value: DisponibiliteEpargne.Transmission,
    label: 'Je souhaite dédier cette épargne à la transmission sans effectuer de retraits.',
  },
];

export const DEFAULT_TOLERANCE_RISQUE_OPTIONS = [
  {
    id: 'Securise',
    value: ToleranceRisque.Securise,
    label:
      "Vous ne tolérez aucun risque en capital et recherchez la sécurité en contrepartie d'un rendement faible. Le profil maximum proposé pour ce placement devra être sécurisé.",
  },
  {
    id: 'Prudent',
    value: ToleranceRisque.Prudent,
    label:
      'Vous tolérez des fluctuations modérées et recherchez une approche prudente privilégiant la protection du capital à la recherche de performance. Le profil proposé pour ce placement ne pourra excéder un profil prudent.',
  },
  {
    id: 'Equilibre',
    value: ToleranceRisque.Equilibre,
    label:
      'Vous êtes prêt à tolérer des hausses et les baisses de votre investissement et privilégiez un équilibre entre le rendement et la sécurité de vos placements. Le profil proposé pour ce placement ne pourra excéder un profil équilibré.',
  },
  {
    id: 'Dynamique',
    value: ToleranceRisque.Dynamique,
    label:
      'Vous acceptez des fluctuations et un risque de perte en capital élevés et recherchez prioritairement une valorisation élevée de votre capital à long terme. Le profil proposé pour ce placement ne pourra excéder un profil dynamique.',
  },
  {
    id: 'Offensif',
    value: ToleranceRisque.Offensif,
    label:
      'Vous acceptez des fluctuations et un risque de perte en capital très élevé et recherchez prioritairement les placements les plus offensifs pour maximiser votre espérance de gains. Le profil proposé pour ce placement ne pourra excéder un profil offensif.',
  },
];
